import { Component, computed, input, ChangeDetectionStrategy } from "@angular/core";
import { CalendarData } from "../../modules/home/calendar/CalendarData";
import { CalendarReservation } from "./calendar.reservation.component";

@Component({
    selector: "s25-ng-calendar-day-reservations",
    standalone: true,
    imports: [CalendarReservation],
    host: {
        class: "CalendarDayEvents",
    },
    styles: `
        :host {
            display: block;
            padding: 4px;
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    template: `
        @for (reservation of reservations(); track reservation.event_id || $index) {
            <!-- TODO: check for first all-day blackout instead? -->
            @let isFirstBlackoutAndAllDay = reservation.all_day && reservation === firstBlackout();
            <s25-ng-calendar-reservation
                [reservation]="reservation"
                [showAllDayHeader]="reservation === firstAllDayEvent() || isFirstBlackoutAndAllDay"
                [lastBlackout]="reservation === lastBlackout()"
                [lastAllDayEvent]="reservation === lastAllDayEvent()"
                [lastAllDayBlackout]="reservation === lastAllDayBlackout()"
            />
        }
        <ng-content />
    `,
})
export class CalendarDayReservations {
    readonly reservations = input.required<Array<CalendarData.Reservation>>();

    readonly allDayEvents = computed(() => this.reservations().filter((e) => e.event_id && e.all_day));
    readonly firstAllDayEvent = computed(() => this.allDayEvents()[0]);
    readonly lastAllDayEvent = computed(() => this.allDayEvents().slice(-1)[0]);
    readonly blackouts = computed(() => this.reservations().filter((e) => !e.event_id));
    readonly firstBlackout = computed(() => this.blackouts()[0]);
    readonly lastBlackout = computed(() => this.blackouts().slice(-1)[0]);
    readonly lastAllDayBlackout = computed(
        () =>
            this.blackouts()
                .filter((b) => b.all_day === 1)
                .slice(-1)[0] || null,
    );
}
